import * as React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Droppable } from "@hello-pangea/dnd";
import { stageNames, stagePlaceholder } from "./stages";
import PurchaseCard from "./PurchaseCard";

const PurchaseColumn = ({ stage, purchaseIds, data, handleDeliverClick }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        flex: 0.4,
        padding: "8px 4px 12px 4px",
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 8,
        margin: theme.spacing(2),
      }}
    >
      <Typography align="center" variant="h6">
        {stageNames[stage]} ({purchaseIds?.length})
      </Typography>
      <Droppable droppableId={stage}>
        {(droppableProvided, snapshot) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            style={{
              display: "flex",
              flexDirection: "column",
              borderRadius: 8,
              margin: theme.spacing(1),
              padding: theme.spacing(0.5),
              ...(snapshot.isDraggingOver && {
                backgroundColor: theme.palette.secondary.main,
              }),
            }}
          >
            {purchaseIds?.length === 0 && (
              <Typography align="center" variant="body1" color="textSecondary">
                {stagePlaceholder[stage]}
              </Typography>
            )}
            {purchaseIds.map((id, index) => {
              return (
                <PurchaseCard
                  key={id}
                  index={index}
                  purchase={data.find((d) => d.id === id)}
                  onDeliverClick={() => handleDeliverClick(id)}
                />
              );
            })}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default PurchaseColumn;
